// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { Tabs } from './Tabs';
import { TabLink } from './TabLink';

type Props = {
  options: [
    {
      name: string,
      path: string,
      nofollow?: boolean
    }
  ],
  path: string
};

export const TabMenu = ({ options, path }: Props) => (
  <Tabs>
    {options.map((option, index) => {
      const rel = option.nofollow ? { rel: 'nofollow' } : {};
      return (
        <TabLink
          as={Link}
          key={index}
          to={option.path}
          {...rel}
          selected={path === option.path || (path === '/preguntas' && option.path === '/preguntas/mas-activas')}
        >
          {option.name}
        </TabLink>
      );
    })}
  </Tabs>
);
